export const AUCTIONS="AUCTIONS";